import * as mojoIdentityServerConstants from './mojo-identity-server-constants';
import { OidcClientConfiguration } from '../models/oidc-client-configuration';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { UserManagerSettings } from 'oidc-client';
import { ClaimTypes } from './claim-types';
import { CommonClaimTypes } from './common-claim-types';
import { UserProfile } from '../models/user-profile';

export const claimTypes = ClaimTypes;
export const commonClaimTypes = CommonClaimTypes;

/**
 * construct a user profile from the "any" structure returned from auth profile.
 */
function userProfileFromAny(profile: any): UserProfile {
  const result = new UserProfile();

  result.userName = profile[commonClaimTypes.PreferredUserName];

  result.roles = [].concat(profile["roles"]);
  result.pmaPermissions = [].concat(profile[mojoIdentityServerConstants.MojoStandardClaimNames.pmaPermission]);
  result.pmaUserDetailsId = profile[mojoIdentityServerConstants.MojoStandardClaimNames.pmaUserDetailsId];
  result.email = profile[mojoIdentityServerConstants.MojoStandardClaimNames.email];
  result.dbIdentity = profile[mojoIdentityServerConstants.MojoStandardClaimNames.dbIdentity];
  result.databaseDisplayName = profile[mojoIdentityServerConstants.MojoStandardClaimNames.databaseDisplayName];
  result.daysLeftBeforePasswordExpires = profile[mojoIdentityServerConstants.MojoStandardClaimNames.DaysLeftBeforePasswordExpires];
    result.authenticatedViaDesktopApp = profile[mojoIdentityServerConstants.MojoStandardClaimNames.authenticatedViaDesktopApp];
    const previousLoginTimesString = profile[mojoIdentityServerConstants.MojoStandardClaimNames.previousLoginTime];
    
    result.previousLoginTime = previousLoginTimesString ? new Date(Date.parse(previousLoginTimesString)) :
        new Date(-8640000000000000);

  return result;
}

/**
 * return the oidcClientConfiguration from siteSpecificData
 */
function getOidcClientConfigFromSiteSpecificData(): OidcClientConfiguration {
  return siteSpecificData.oidcClientConfiguration;
}

/**
 * gets the client configuration settings in a form suitable for oidc-client
 */
function getClientSettings(): UserManagerSettings {
  return augmentOidcConfiguration(getOidcClientConfigFromSiteSpecificData()) as UserManagerSettings;
}

/**
 * Returns a string containing the requested scopes
 */
function mojoPlatformScopeString(): string {
  const scopes = [
    mojoIdentityServerConstants.OpenIdStandardScopes.openId,
    mojoIdentityServerConstants.OpenIdStandardScopes.profile,
    mojoIdentityServerConstants.MojoStandardScopes.mciUserIdentity,
    mojoIdentityServerConstants.MojoStandardScopes.mojoClientInvestorsApi,
    mojoIdentityServerConstants.MojoStandardScopes.mojoIdentityAdministrationApi,
    mojoIdentityServerConstants.MojoStandardScopes.mojoOnlineFormsApi
  ];
  return scopes.join(' ');
}

/**
 * Returns an OidcClientConfiguration object populated with the application constant values
 */
function appSpecificOidcConfiguration(): OidcClientConfiguration {
  const config = new OidcClientConfiguration();
  config.client_id = mojoIdentityServerConstants.ClientIdentifiers.mojoPlatform;
  config.response_type = mojoIdentityServerConstants.ReponseTypes.IdTokenAndToken;
  config.scope = mojoPlatformScopeString();
  config.filterProtocolClaims = true;
  config.loadUserInfo = true;
  return config;
}

/**
 * Augments the provided config object with the appSpecificSettings unless they are specified
 * @param config the site specific configuration to be augmented
 */
function augmentOidcConfiguration(config: OidcClientConfiguration): OidcClientConfiguration {
  return { ...config, ...appSpecificOidcConfiguration() };
}

export {
  userProfileFromAny,
  getOidcClientConfigFromSiteSpecificData,
  getClientSettings,
  mojoPlatformScopeString,
  appSpecificOidcConfiguration,
  augmentOidcConfiguration
}
